module.exports = __webpack_public_path__ + "img/game--knockout-city--esrb.356688f6.png";